import { createSlice, PayloadAction } from "@reduxjs/toolkit";

type FilterPayload = Record<string, string>;
interface FiltersState {
  primaryFilters: FilterPayload;
  secondaryFilters: FilterPayload;
  filterListNameToFetch: string;
  sort: "asc" | "desc";
}

const initialState: FiltersState = {
  primaryFilters: {},
  secondaryFilters: {},
  filterListNameToFetch: "",
  sort: "desc",
};

export const filtersSlice = createSlice({
  name: "filter",
  initialState,
  reducers: {
    resetFilters: () => initialState,
    resetSecondaryFilters: (state) => {
      state.secondaryFilters = {};
    },
    setFilterListNameToFetch: (state, { payload }) => {
      state.filterListNameToFetch = payload;
    },
    setPrimaryFilters: (state, action) => {
      state.primaryFilters = action.payload;
    },
    setSecondaryFilters: (state, action: PayloadAction<FilterPayload>) => {
      state.secondaryFilters = action.payload;
    },
    setSort: (state, action: PayloadAction<"asc" | "desc">) => {
      state.sort = action.payload;
    },
  },
});

export const {
  resetSecondaryFilters,
  resetFilters,
  setFilterListNameToFetch,
  setPrimaryFilters,
  setSecondaryFilters,
  setSort,
} = filtersSlice.actions;

export default filtersSlice.reducer;
